import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConstants, ContentService, Message, Service } from '../_core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '../_core/_services/message.service';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit, OnDestroy {

  slug = 'contact'
  content: any

  message: Message
  fields: any
  // fields = {
  //   banner_text: 'Contact Us',
  //   // banner_button_text: 'Request a Quote',
  //   // banner_button_path: '/contact',
  //   banner_src: 'https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/v1710291303/banner-bouquet_wetqze.webp',
  //   banner_id: 'banner-bouquet_wetqze',
  //   banner_ar: 2
  // }

  form!: FormGroup
  get f() { return this.form.controls }

  submitted: boolean
  isLoading: boolean
  isSubmitting: boolean
  isValid: boolean
  recaptchaResponse: any

  backendErrors: any = {}

  messageTypes = [
    { value: 'new-business',
      display: 'New Business' },

    { value: 'general-inquiry',
      display: 'General Inquiry' }
  ]

  defaults = {
    name: null,
    email: null,
    body: null,
    message_type: null,
  }
  // defaults = {
  //   name: 'corey',
  //   email: 'cbgravelle@gmail.com',
  //   body: "Test message\n...\nhere!",
  //   message_type: null,
  // }

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    // private appHelper: AppHelper,
    private cdr: ChangeDetectorRef,
    private contentService: ContentService,
    // private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private matSnackbar: MatSnackBar,
    private messageService: MessageService
  ){}

  ngOnInit(): void {
    this.getPage()
    this.initForm()
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }


  getPage(){
    // this.contentService.getPage({'fields.slug': 'home', 'fields.version': 2 })
    this.contentService.getPage({ 'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        this.fields = this.content.items[0].fields
        // console.log('fields', this.fields);
      }
    });
  }

  initForm() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(AppConstants.EMAIL_REGEX)]],
      body: ['', [Validators.required]],
      message_type: ['', [Validators.required]],
      recaptcha_response: ['', [Validators.required]]
    });
    
    this.populateFormValues()
  }

  populateFormValues() {
    if (!this.form) return
    if (!this.defaults || !this.message) return
    let params = this.message || this.defaults
    this.form.setValue({
      name: params.name || null,
      email: params.email || null,
      body: params.body || null,
      message_type: params.message_type || null,
      recaptcha_response: null
    })
  }

  handleSelectMessageType(evt?: any) {
    // messageTypes
    // console.log('handleSelect', evt)
    this.form.controls['message_type'].setValue(evt.value)
  }

  handleSubmit() {
    this.isSubmitting = true
    this.submitted = true
    // console.log('handleSubmit (FORM)', this.form.value, this.checkService )

    // this.updateForm()
    if (this.recaptchaResponse) this.form.controls.recaptcha_response.setValue(this.recaptchaResponse)

    if (!this.form.valid) {
      // console.log('!invalid', this.form)
      this.isValid = false
      this.updateSubmitting(false)
    } else {
      this.isValid = true
      // console.log('onSubmit', this.form.value)
      // console.log('TODO: REMOVE COMMENT')
      // this.onSubmit.emit(this.form.value)
      return firstValueFrom(this.messageService.create(this.form.value)).then(res => {
        // console.log('RES', res)
        // console.log('HANDLE RES')
        this.updateSubmitting(false)
        // exit unless order returned
        if (!res || res['klass'] != 'Message' || !res['id']) return
        // navigate to thank-you
        // console.log('>>>>> TODO REIMPLEMENT contact redir')
        this.router.navigateByUrl('/')
        this.matSnackbar.open('Thanks for reaching out! We will get back to you as soon as possible.', 'close', { duration: 10000 });

      }).catch(err => {
        console.log('CONTACT ERR', err)
        this.updateSubmitting(false)
      })
    }
  }

  updateSubmitting(isSubmitting: boolean) {
    this.isLoading = isSubmitting
    this.isSubmitting = isSubmitting
  }

  handleCorrectCaptcha(res: any) {
    // console.log('CORRECT', res)
    this.recaptchaResponse = res
  }

  handleExpiredCaptcha(res: any) {
    console.log('ERR: expired', res)
    this.recaptchaResponse = null
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}
